<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="17" height="17" rx="5" fill="#1F2D3D" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.921 4.74911L6.90625 9.76385L5.07902 7.93661C4.76634 7.63462 4.26933 7.63894 3.96195 7.94632C3.65456 8.2537 3.65025 8.75072 3.95224 9.0634L6.34286 11.454C6.65404 11.7651 7.15847 11.7651 7.46965 11.454L13.0478 5.87589C13.3498 5.56322 13.3454 5.0662 13.0381 4.75882C12.7307 4.45144 12.2337 4.44712 11.921 4.74911Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
  name: "CheckDefualtIcon",
};
</script>
